import React, { useState, useMemo, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Paper,
  Chip,
  Box,
  Grid,
  Badge,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Stack,
  TableContainer,
  TableSortLabel,
  useMediaQuery,
  useTheme,
  Checkbox,
} from "@mui/material";
import { useFormik } from "formik";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import TablePagination from "@mui/material/TablePagination";
import Tooltip from "@mui/material/Tooltip";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SettingsIcon from "@mui/icons-material/Settings";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { getFormattedDate } from "../../components/common/dataValidation";
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  MuiAutocomplete,
  MuiTooltip,
  ConfirmDialog,
  CommonCurdPopUp,
  MyTextInput,
  MuiDataGrid,
} from "../../components";
import EmailIcon from "@mui/icons-material/Email";
import { Virtuoso } from "react-virtuoso";
import {
  getBatchPublishAssessment,
  sendReminderByUserId,
  getPublishPreviewReminderByAssessmentId,
  publishBatchAssessmentReminder,
  deleteBatchAssessment,
  assessorRowSelect,
  getBatchNonPublishAssessment,
  deletePublishAssessmentFromGroup,
  rowSelect,
  createAssessmentExistingBatch,
  getBatchPublishAssessmentById,
  publishBatchAssessment,
  resetMessage,
  resetErrMessage,
} from "../../features/config_and_publish/publishAssessmentSlice";
import { getAccountById } from "../../features/customer/accountSlice";
//react-redux
import { useSelector, useDispatch } from "react-redux";

export default function AssessmentGroups(props) {
  const [open, setOpen] = useState(false);
  const [isViewClientAssessor, setIsViewClientAssessor] = useState(true);
  const [showAssessor, setShowAssessor] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [batchAssessment, setBatchAssessment] = useState(null);
  const [showAssessmentUsers, setShowAssessmentUsers] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [pageUsers, setPageUsers] = useState(0);
  const [rowsPerPageUsers, setRowsPerPageUsers] = useState(10);

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState({
    clients: [],
    assessors: [],
  });
  const [sortField, setSortField] = useState("groupName");
  const [sortOrder, setSortOrder] = useState("asc");
  const [customer, setCustomer] = useState(null);
  const [account, setAccount] = useState(null);
  const { assessmentTypeData, assessmentType } = useSelector((state) => ({
    ...state.assessmentTypeConfig,
  }));
  const { accountData, accountIdData } = useSelector((state) => ({
    ...state?.account,
  }));
  const { customersData } = useSelector((state) => ({ ...state.customer }));

  const {
    batchAssessmentData,
    batchAssessmentReminderUsersData,
    nonPublishAssessmentData,
    assessorSelectedData,
    selectedData,
    batchAssessmentListViewData,
    publishAssessmentData,
    loading,
  } = useSelector((state) => ({ ...state.publishAssessment }));
  const dispatch = useDispatch();

  const groups = [
    {
      id: 1,
      groupName: "Kirloskar Cohort",
      members: 7,
      assessmentType: "EU Assessment",
      status: "Draft",
      summary: {
        clientMail: 7,
        assessorMail: 17,
      },
      assessments: [
        {
          id: 1,
          assessmentName: "Kirloskar Operation Assessment",
          clientName: "Google8 User8",
          email: "poojs.bs+g3@pioneer.com",
          cutOffDate: "06/25/2026",
          status: "Pending",
        },
        {
          id: 2,
          assessmentName: "Kirloskar Operation Assessment",
          clientName: "Google10 User8",
          email: "poojs.bs+g3@pioneer.com",
          cutOffDate: "06/25/2026",
          status: "Complated",
        },
      ],
    },
    {
      id: 2,
      groupName: "Kirloskar Cohort",
      members: 7,
      assessmentType: "EU Assessment",
      status: "Draft",
      summary: {
        clientMail: 7,
        assessorMail: 17,
      },
      assessments: [
        {
          id: 1,
          assessmentName: "Kirloskar Operation Assessment",
          clientName: "Google8 User8",
          email: "poojs.bs+g3@pioneer.com",
          cutOffDate: "06/25/2026",
          status: "Pending",
        },
        {
          id: 2,
          assessmentName: "Kirloskar Operation Assessment",
          clientName: "Google10 User8",
          email: "poojs.bs+g3@pioneer.com",
          cutOffDate: "06/25/2026",
          status: "Complated",
        },
      ],
    },
  ];

  const theme = useTheme();
  const isLaptopAndAbove = useMediaQuery(theme.breakpoints.up("md"));
  const isNotLaptop = !isLaptopAndAbove;
  console.log(isNotLaptop);

  function AssessmentTable({ batch, assessments }) {
    const columns = [
      { field: "assessmentName", header: "Assessment Name", width: 250 },
      { field: "clientName", header: "Client Name", width: 200 },
      { field: "clientEmail", header: "Client Email", width: 200 },
      { field: "cutOffDate", header: "Cut Off Date", width: 150 },
      { field: "settings", header: "Assessors", width: 80 },
      { field: "status", header: "Status", width: 120 },
      { field: "action", header: "Action", width: 120 },
      { field: "customerName", header: "Customer Name", width: 200 },
      { field: "accountName", header: "Account Name", width: 200 },
      { field: "assessmentType", header: "Assessment Type", width: 200 },
    ];

    const handleSelectAll = (event) => {
      if (event.target.checked) {
        setSelectedRows(assessments.map((item) => item.assessmentTrackingId));
      } else {
        setSelectedRows([]);
      }
    };

    const handleRowSelect = (item) => {
      const id = item.assessmentTrackingId;

      setSelectedRows((prev) =>
        prev.includes(id)
          ? prev.filter((rowId) => rowId !== id)
          : [...prev, id],
      );
    };
    const totalColumnWidth = columns.reduce((sum, col) => sum + col.width, 0);

    console.log(selectedRows);

    return (
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          overflowX: "auto",
          border: "1px solid #E5E7EB",
          borderRadius: "8px",
        }}
      >
        <Table
          size="small"
          size="small"
          sx={{
            width: "100%",
            minWidth: totalColumnWidth,
          }}
        >
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "#E5E7EB",
                "& th": {
                  fontWeight: 600,
                  color: "#374151",
                  borderBottom: "1px solid #D1D5DB",
                  whiteSpace: "nowrap",
                },
              }}
            >
              {batchAssessment?.id && (
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={
                      assessments.length > 0 &&
                      selectedRows.length === assessments.length
                    }
                    indeterminate={
                      selectedRows.length > 0 &&
                      selectedRows.length < assessments.length
                    }
                    onChange={handleSelectAll}
                  />
                </TableCell>
              )}
              {columns?.map((column) => (
                <TableCell
                  key={column.field}
                  sx={{
                    width: `${100 / columns.length}%`,
                    minWidth: column.width,
                  }}
                >
                  {column.header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {assessments?.map((item) => (
              <TableRow
                key={item.assessmentTrackingId}
                hover
                selected={selectedRows.includes(item.assessmentTrackingId)}
                sx={{
                  backgroundColor: "#F9FAFB",
                  "&:hover": {
                    backgroundColor: "#F3F4F6",
                  },
                  "& td": {
                    borderBottom: "1px solid #E5E7EB",
                  },
                }}
              >
                {batchAssessment?.id && (
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedRows.includes(item.assessmentTrackingId)}
                      onChange={() => handleRowSelect(item)}
                    />
                  </TableCell>
                )}
                <TableCell sx={{ width: columns[0].width }}>
                  {item.templateName || item.assessmentTemplateName}
                </TableCell>

                <TableCell sx={{ width: columns[1].width }}>
                  {item.clientName}
                </TableCell>

                <TableCell sx={{ width: columns[2].width }}>
                  {item.clientEmail}
                </TableCell>

                <TableCell sx={{ width: columns[3].width }}>
                  {getFormattedDate(item.cutOffDate)}
                </TableCell>

                <TableCell sx={{ width: columns[4].width }}>
                  <IconButton
                    aria-label="setting"
                    onClick={() => {
                      dispatch(assessorRowSelect([item]));
                      setShowAssessor(true);
                    }}
                  >
                    <MuiTooltip title="Assessors" placement="bottom">
                      <SettingsIcon sx={{ color: "#808080" }} />
                    </MuiTooltip>
                  </IconButton>
                </TableCell>

                <TableCell sx={{ width: columns[5].width }}>
                  {item.status}
                </TableCell>

                <TableCell sx={{ width: columns[6].width }}>
                  {item.status != "Published" && (
                    <Button
                      size="small"
                      variant="outlined"
                      color="error"
                      onClick={() => showAssessmentDelete(batch, item)}
                    >
                      Remove
                    </Button>
                  )}
                </TableCell>

                <TableCell sx={{ width: columns[7].width }}>
                  {batch?.assessmentCustomer?.customerName}
                </TableCell>

                <TableCell sx={{ width: columns[8]?.width }}>
                  {batch?.assessmentCustomerAccount?.accountName}
                </TableCell>

                <TableCell sx={{ width: columns[9]?.width }}>
                  {item?.assessmentType}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  const [expandedRows, setExpandedRows] = useState([]);

  const toggleExpand = (id) => {
    setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const data = {
    rows:
      assessorSelectedData?.assessors?.length > 0
        ? assessorSelectedData?.assessors.map((data, index) => ({
            ...data,
            id: index + 1,
          }))
        : [],
    columns: [
      {
        field: "assessorName",
        headerName: "Assessor Name",
        width: 250,

        // valueGetter: getClient,
      },
      {
        field: "assessorEmail",
        headerName: "Assessor E-Mail",
        width: 250,
        // renderCell: getClientEmail,
        // valueGetter: (params) => params?.row?.assessmentCustomerUser?.email,
      },
      { field: "relationshipType", headerName: "Relationship", width: 150 },

      {
        field: "responseStatuscomments",
        headerName: "Comments",
        width: 350,
        // renderCell: renderCellExpand,
      },
    ],
  };

  // separate dropdown data and list view data

  const sortedGroups = useMemo(() => {
    const data = Array.isArray(batchAssessmentData?.data)
      ? batchAssessmentData.data
      : typeof batchAssessmentData?.data === "object"
        ? [batchAssessmentData.data]
        : [];

    let finalSortedData = [...data].sort((a, b) => {
      const valueA = a[sortField];
      const valueB = b[sortField];

      return sortOrder === "asc"
        ? String(valueA ?? "").localeCompare(String(valueB ?? ""))
        : String(valueB ?? "").localeCompare(String(valueA ?? ""));
    });

    setSelectedRows(
      finalSortedData?.[0]?.assessments?.map(
        (item) => item.assessmentTrackingId,
      ) || [],
    );

    return finalSortedData;
    // setSelectedRows(finalSortedData)
  }, [batchAssessmentData?.data, sortField, sortOrder]);

  const paginatedGroups = sortedGroups.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  //showing the modal for Publishing the Batch Assessment
  const showPublish = () => {
    setIsViewClientAssessor(false);
    setConfirmDialog({
      isOpen: true,
      title: "Attention!",
      subTitle:
        "Clicking this button will send an email to the designated recipients. Please Preview the information before proceeding. Once sent, emails cannot be retrieved.",
      onConfirm: () => handlePublishBatch(),
    });
  };

  const showDelete = (data) => {
    setIsViewClientAssessor(false);
    setConfirmDialog({
      isOpen: true,
      title: "Are you sure to delete this record?",
      subTitle: "You can't undo this operation",
      onConfirm: () => handleDeleteBatch(data.id),
    });
  };

  const showAssessmentDelete = (batch, data) => {
    console.log(data);
setIsViewClientAssessor(false);
    setConfirmDialog({
      isOpen: true,
      title: "Are you sure to remove this record?",
      subTitle: "You can't undo this operation",
      onConfirm: () => handleRemoveBatch(batch?.id, data.assessmentTrackingId),
    });
  };

  const showBatchAssessmentReminderModal = (batch, data) => {
    setConfirmDialog({
      isOpen: true,
      title: "Are you sure to send the Email?",
      subTitle: "You can't undo this operation",
      onConfirm: () => handlePublishBatchSendReminder(),
    });
  };

  const handlePublishBatchSendReminder = () => {
    let data = {
      batchId: batchAssessment?.id,
      assessmentTrackingIds: selectedRows,
      // recipients: selectedRows,
    };
    dispatch(publishBatchAssessmentReminder(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          dispatch(
            getBatchPublishAssessment({ id: batchAssessmentData?.data?.id }),
          );
        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 3000);
      }
    });
  };

  const handleSetConfirmDialog = (obj) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: obj.isOpen,
    });
  };

  //Api call execution for batch Publish Assessments

  const handlePublishBatch = () => {
    let data = {
      id: batchAssessmentData?.data?.id,
    };
    dispatch(publishBatchAssessment(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          dispatch(
            getBatchPublishAssessment({ id: batchAssessmentData?.data?.id }),
          );
        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 3000);
      }
    });
  };

  const handleDeleteBatch = (dataId) => {
    let data = {
      id: dataId,
    };
    dispatch(deleteBatchAssessment(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          dispatch(getBatchPublishAssessmentById());
          setBatchAssessment(null);
        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 3000);
      }
    });
  };

  const handleRemoveBatch = (batchId, dataId) => {
    console.log(dataId);
    let data = {
      batchId: batchId,
      assessmentTrackingId: dataId,
    };
    dispatch(deletePublishAssessmentFromGroup(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          Array.isArray(batchAssessmentData?.data)
            ? dispatch(getBatchPublishAssessmentById())
            : dispatch(
                getBatchPublishAssessment({
                  id: batchAssessmentData?.data?.id,
                }),
              );
        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 3000);
      }
    });
  };

  const handleClear = () => {
    setCustomer("");
    setAccount("");
    dispatch(getBatchPublishAssessmentById());
    // setAssessmentType("");
  };

  const handleApply = () => {
    // API Call / Filtering Logic
    setOpen(false);
  };

  const showAddModel = () => {
    setShowAdd(!showAdd);
    dispatch(
      getBatchNonPublishAssessment(
        batchAssessmentData?.data?.assessmentCustomerAccount?.id,
      ),
    );
  };

  const showAssessmentUsersModal = () => {
    setShowAssessmentUsers(!showAssessmentUsers);
    dispatch(
      getPublishPreviewReminderByAssessmentId(
        {
          batchId: batchAssessment?.id,
          ...(selectedRows?.length > 0 && {
            assessmentTrackingIds: selectedRows,
          }),
        },
        // recipients: selectedRows,}
      ),
    );
  };

  const closeModel = () => {
    setShowAdd(false);

    // formik.resetForm({
    //     values: {
    //         account,
    //         custName,
    //         assessmentType: assessmentType,
    //         assessment: "",
    //         client: "",
    //         status: "",
    //         comments: "",
    //     },
    // });
    // dispatch(getAccount())
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      assessment: [],
      batchName: batchAssessmentData?.data?.name,
    },

    // validationSchema: validationSchema,
    onSubmit: async (values, onSubmitProps) => {
      const res = await dispatch(
        createAssessmentExistingBatch({
          batchId: batchAssessmentData?.data?.id,
          assessmentTrackingIds: values?.assessment?.map((data) => data?.id),
          // assessmentTypeId: values?.assessmentType?.id,
        }),
      ).then((res) => {
        if (res?.payload?.data?.ok) {
          setTimeout(() => {
            dispatch(resetMessage());
            closeModel();
            dispatch(
              getBatchPublishAssessment({ id: batchAssessmentData?.data?.id }),
            );
            onSubmitProps.resetForm();
          }, 2000);
          return true;
        }
        if (res?.payload?.error) {
          setTimeout(() => {
            dispatch(resetErrMessage());
          }, 3000);
        }
        return false;
      });
      return res;
    },
  });

  const handleSubmit = async () => {
    if (showAdd) {
      const result = await formik.submitForm();
      return result;
    }
  };

  const columnWidths = {
    expand: 60,
    batchName: 250,
    assessments: 150,
    summary: 150,
    status: 120,
    actions: 120,
    customer: 200,
    account: 200,
  };

  const tableWidth = 1250;

  const columns = [
    {
      field: "expand",
      label: "",
      width: columnWidths.expand,
      sortable: false,
    },
    {
      field: "groupName",
      label: "Batch Name",
      width: columnWidths.batchName,
      sortable: false,
    },
    {
      field: "assessments",
      label: "Assessments",
      width: columnWidths.assessments,
      sortable: true,
    },
    {
      field: "summary",
      label: "Summary",
      width: columnWidths.summary,
      sortable: true,
    },
    {
      field: "status",
      label: "Status",
      width: columnWidths.status,
      sortable: true,
    },
    // {
    //   field: "edit",
    //   label: "",
    //   width: columnWidths.actions,
    //   sortable: false,
    // },
    {
      field: "email",
      label: "Actions",
      width: columnWidths.actions,
      sortable: false,
    },
    {
      field: "customerName",
      label: "Customer Name",
      width: columnWidths.customer,
      sortable: true,
    },
    {
      field: "accountName",
      label: "Account Name",
      width: columnWidths.account,
      sortable: true,
    },
  ];

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const userscolumns = [
    { field: "clientName", header: "Client/Assessor Name", width: 200 },
    { field: "clientEmail", header: "Email", width: 200 },
    { field: "role", header: "Role", width: 200 },
  ];

  const clientAssessorsData =
    selectedRows?.length > 0
      ? [
          ...(batchAssessmentReminderUsersData?.data?.clients || []),
          ...(batchAssessmentReminderUsersData?.data?.assessors || []),
        ]
      : [];

  useEffect(() => {
    setSelectedUsers({
      clients: [
        ...(batchAssessmentReminderUsersData?.data?.clients?.map(
          (data) => data?.id,
        ) ?? []),
      ],
      assessors: [
        ...(batchAssessmentReminderUsersData?.data?.assessors?.map(
          (data) => data?.id,
        ) ?? []),
      ],
    });
  }, [batchAssessmentReminderUsersData]);

  console.log(sortedGroups);

  const handleRowSelect = (item) => {
    const { role, id } = item; // or item.userId if that's your id field

    setSelectedUsers((prev) => {
      const key = role === "client" ? "clients" : "assessors";

      const alreadySelected = prev[key].includes(id);

      return {
        ...prev,
        [key]: alreadySelected
          ? prev[key].filter((userId) => userId !== id)
          : [...prev[key], id],
      };
    });
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const clients = clientAssessorsData
        ?.filter((item) => item.role === "client")
        ?.map((item) => item.id);

      const assessors = clientAssessorsData
        ?.filter((item) => item.role === "assessor")
        ?.map((item) => item.id);

      setSelectedUsers({
        clients,
        assessors,
      });
    } else {
      setSelectedUsers({
        clients: [],
        assessors: [],
      });
    }
  };

  const totalSelected =
    selectedUsers.clients.length + selectedUsers.assessors.length;

  const showSendSelectedReminder = (data) =>
    setConfirmDialog({
      isOpen: true,
      title:
        "Are you sure you want to send reminder emails to the selected clients and assessors? Only the selected users will receive the reminder.",
      subTitle: "You can't undo this operation",
      onConfirm: () => sendReminderEmailBySelection(),
    });

  const sendReminderEmailBySelection = async () => {
    const res = await dispatch(
      sendReminderByUserId({
        batchId: batchAssessmentData?.data?.id,
        clientIds: selectedUsers?.clients,
        assessorIds: selectedUsers?.assessors,
        // assessmentTypeId: values?.assessmentType?.id,
      }),
    ).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          dispatch(
            getPublishPreviewReminderByAssessmentId({
              batchId: batchAssessment?.id,
              assessmentTrackingIds: selectedRows,
            }),
          );
        }, 2000);
        return true;
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 3000);
      }
      return false;
    });
    return res;
  };

  return (
    <div style={{ paddingBottom: "1rem" }}>
      <Box>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={3.1} sx={{ mb: 2 }}>
            <MuiAutocomplete
              name="batchAssessment"
              options={
                batchAssessmentListViewData?.data
                  ? batchAssessmentListViewData?.data
                  : []
              }
              setValue={(name, newValue) => {
                setBatchAssessment(newValue);
                if (newValue) {
                  dispatch(getBatchPublishAssessment({ id: newValue?.id }));
                } else {
                  dispatch(
                    getBatchPublishAssessmentById({
                      customerId: customer?.id,
                      accountId: account?.id,
                    }),
                  );
                }
                setExpandedRows([]);
              }}
              value={batchAssessment}
              size="small"
              height="100%"
              fullWidth={true}
              noMargin
              optionValue="name"
              // optionSecValue="code"
              label="Select or Search Batch"
            />
          </Grid>

          <Grid item>
            <Button
              variant="contained"
              onClick={() => {
                props?.showModal();
                setBatchAssessment(null);
                dispatch(getBatchPublishAssessmentById());
              }}
            >
              Create Batch
            </Button>
          </Grid>

          <Grid item pb={0.8}>
            <Tooltip
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "#FFFFFF",
                    color: "#000000",
                    border: "1px solid #D9E2EC",
                    boxShadow: "0px 4px 12px rgba(0,0,0,0.12)",
                    maxWidth: 350,
                    p: 2,
                  },
                },
                arrow: { sx: { color: "#FFFFFF" } },
              }}
              placement="bottom-start"
              title={
                <>
                  <Typography variant="subtitle2" fontWeight={600}>
                    Eligibility Criteria
                  </Typography>

                  <Typography variant="body2">
                    Assessments that meet the following conditions can be added
                    to a batch:
                  </Typography>

                  <ul style={{ margin: "8px 0 0 16px", padding: 0 }}>
                    <li>Cut-off Date is today or later.</li>
                    <li>Assessment Template status is Completed.</li>
                    <li>Assessment Template contains at least one question.</li>
                    <li>Assessment has not been published.</li>
                    <li>Assessment is not assigned to another active batch.</li>
                  </ul>
                </>
              }
            >
              <InfoOutlinedIcon
                color="primary"
                sx={{
                  fontSize: 25,

                  cursor: "pointer",
                  marginTop: "1rem",
                }}
              />
            </Tooltip>
          </Grid>

          <Grid item xs />

          <Grid item>
            {batchAssessment?.id && sortedGroups[0]?.status === "Published" && (
              <IconButton
                aria-label="email"
                onClick={showAssessmentUsersModal}
                sx={{ marginRight: "1rem" }}
              >
                <MuiTooltip title="Select and Send Reminder" placement="bottom">
                  <EmailIcon color="primary" fontSize="1rem" />
                </MuiTooltip>
              </IconButton>
            )}

            <IconButton
              aria-label="filter"
              sx={{ marginRight: "1rem" }}
              onClick={() => setOpen(true)}
            >
              <Badge
                badgeContent={(customer ? 1 : 0) + (account ? 1 : 0)}
                color="primary"
              >
                <MuiTooltip title="Filters" placement="bottom">
                  <FilterListIcon color="primary" fontSize="1rem" />
                </MuiTooltip>
              </Badge>
            </IconButton>
            <Button
              disabled={batchAssessment?.id ? false : true}
              variant="contained"
              onClick={showAddModel}
            >
              Add Assessments
            </Button>
          </Grid>

          <Grid item>
            <Button
              disabled={batchAssessment?.id ? false : true}
              variant="contained"
              onClick={showPublish}
            >
              Publish
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          overflowX: "auto",
          overflowY: "hidden",
        }}
      >
        <Box
          sx={{
            width: `${tableWidth}px`,
            minWidth: `${tableWidth}px`,
          }}
        >
          {/* ================= HEADER ================= */}
          <Table
            sx={{
              width: `${tableWidth}px`,
              minWidth: `${tableWidth}px`,
              tableLayout: "fixed",
            }}
          >
            <TableHead
              sx={{
                border: "1px solid #D9E2EC",
                borderBottom: "none",
                borderRadius: "6px 6px 0 0",
                overflow: "hidden",
              }}
            >
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.field}
                    sx={{
                      width: column.width,
                      minWidth: column.width,
                      maxWidth: column.width,
                      boxSizing: "border-box",
                      cursor: column.sortable ? "pointer" : "default",
                      fontWeight: 600,
                    }}
                    onClick={() => column.sortable && handleSort(column.field)}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        overflow: "hidden",
                      }}
                    >
                      {column.label}

                      {column.sortable &&
                        sortField === column.field &&
                        (sortOrder === "asc" ? (
                          <ArrowUpwardIcon
                            sx={{
                              color: "#9CA3AF",
                              fontSize: 20,
                            }}
                          />
                        ) : (
                          <ArrowDownwardIcon
                            sx={{
                              color: "#9CA3AF",
                              fontSize: 20,
                            }}
                          />
                        ))}
                    </Box>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
          </Table>

          {/* ================= BODY ================= */}
          <Virtuoso
            style={{
              height: 400,
              width: `${tableWidth}px`,
              border: "1px solid #D9E2EC",
              borderTop: "none",
              borderRadius: "0 0 6px 6px",
              overflowX: "hidden",
            }}
            totalCount={sortedGroups.length}
            itemContent={(index) => {
              const group = sortedGroups[index];
              const expanded = expandedRows?.includes(group?.id);

              return (
                <Table
                  sx={{
                    width: `${tableWidth}px`,
                    minWidth: `${tableWidth}px`,
                    tableLayout: "fixed",
                  }}
                >
                  <TableBody>
                    <TableRow
                      sx={{
                        backgroundColor:
                          index % 2 === 0 ? "#c4e1f1" : "#FFFFFF",

                        "&:hover": {
                          backgroundColor:
                            index % 2 === 0 ? "#CFE2F3" : "#F5F9FD",
                        },

                        "& td": {
                          borderBottom: "1px solid #E5E7EB",
                          boxSizing: "border-box",
                        },
                      }}
                    >
                      {/* Expand */}
                      <TableCell
                        sx={{
                          width: columnWidths.expand,
                          minWidth: columnWidths.expand,
                          maxWidth: columnWidths.expand,
                          boxSizing: "border-box",
                        }}
                      >
                        <IconButton
                          aria-label="Expand batch"
                          onClick={() => toggleExpand(group.id)}
                        >
                          {expanded ? (
                            <KeyboardArrowDownIcon />
                          ) : (
                            <KeyboardArrowRightIcon />
                          )}
                        </IconButton>
                      </TableCell>

                      {/* Batch Name */}
                      <TableCell
                        sx={{
                          width: columnWidths.batchName,
                          minWidth: columnWidths.batchName,
                          maxWidth: columnWidths.batchName,
                          boxSizing: "border-box",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {group.name}
                      </TableCell>

                      {/* Assessments */}
                      <TableCell
                        sx={{
                          width: columnWidths.assessments,
                          minWidth: columnWidths.assessments,
                          maxWidth: columnWidths.assessments,
                          boxSizing: "border-box",
                        }}
                      >
                        {group.assessmentCount} assessments
                      </TableCell>

                      {/* Summary */}
                      <TableCell
                        sx={{
                          width: columnWidths.summary,
                          minWidth: columnWidths.summary,
                          maxWidth: columnWidths.summary,
                          boxSizing: "border-box",
                        }}
                      >
                        {group?.clientMails} client mail
                        <br />
                        {group?.assessorMails} assessor mail
                      </TableCell>

                      {/* Status */}
                      <TableCell
                        sx={{
                          width: columnWidths.status,
                          minWidth: columnWidths.status,
                          maxWidth: columnWidths.status,
                          boxSizing: "border-box",
                        }}
                      >
                        <Chip label={group.status} size="small" />
                      </TableCell>

                      {/* Actions */}
                      {/* <TableCell
                        sx={{
                          width: columnWidths.actions,
                          minWidth: columnWidths.actions,
                        //   maxWidth: columnWidths.actions,
                          boxSizing: "border-box",
                        }}
                      ></TableCell> */}
                      <TableCell
                        sx={{
                          width: columnWidths.actions,
                          minWidth: columnWidths.actions,
                          maxWidth: columnWidths.actions,
                          boxSizing: "border-box",
                        //   background:"red",
                          display: "flex",
                          flexDirection:"row",
                        alignItems: "flex-start"
                        }}
                      >
                        <Box
                          sx={{
                            
                            gap: 1,
                          }}
                        >
                          {batchAssessment?.id &&
                            group.status === "Published" && (
                              <IconButton
                                aria-label="Send reminder"
                                size="small"
                                onClick={showBatchAssessmentReminderModal}
                              >
                                <MuiTooltip
                                  title="Send Reminder"
                                  placement="bottom"
                                >
                                  <EmailIcon
                                    color="primary"
                                    // fontSize="small"
                                  />
                                </MuiTooltip>
                              </IconButton>
                            )}

                          {group.status !== "Published" && (
                            <IconButton
                              aria-label="Edit batch"
                              size="small"
                              onClick={() => {
                                props?.showEditModal();
                                dispatch(rowSelect([group]));
                              }}
                            >
                              <MuiTooltip title="Edit Batch" placement="bottom">
                                <EditOutlinedIcon
                                  color="primary"
                                  // fontSize="small"
                                />
                              </MuiTooltip>
                            </IconButton>
                          )}

                          {group.status !== "Published" && (
                            <IconButton
                              aria-label="Delete batch"
                              color="error"
                              size="small"
                              onClick={() => showDelete(group)}
                            >
                              <MuiTooltip
                                title="Delete Batch"
                                placement="bottom"
                              >
                                <DeleteOutlineOutlinedIcon
                                // fontSize="small"
                                />
                              </MuiTooltip>
                            </IconButton>
                          )}
                        </Box>
                      </TableCell>

                      {/* Customer */}
                      <TableCell
                        sx={{
                          width: columnWidths.customer,
                          minWidth: columnWidths.customer,
                          maxWidth: columnWidths.customer,
                          boxSizing: "border-box",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {group?.assessmentCustomer?.customerName}
                      </TableCell>

                      {/* Account */}
                      <TableCell
                        sx={{
                          width: columnWidths.account,
                          minWidth: columnWidths.account,
                          maxWidth: columnWidths.account,
                          boxSizing: "border-box",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {group?.assessmentCustomerAccount?.accountName}
                      </TableCell>
                    </TableRow>

                    {/* Expanded Assessment */}
                    {expanded && (
                      <TableRow>
                        <TableCell
                          colSpan={8}
                          sx={{
                            padding: 0,
                            borderBottom: "none",
                          }}
                        >
                          <AssessmentTable
                            batch={group}
                            assessments={group?.assessments}
                          />
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              );
            }}
          />
        </Box>
      </Box>
      <TablePagination
        component="div"
        count={sortedGroups.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={(e, newPage) => setPage(newPage)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[10, 25, 50]}
        sx={{
          border: "1px solid #D9E2EC",
          borderTop: "none",
          backgroundColor: "#fff",
          ".MuiTablePagination-toolbar": {
            minHeight: 52,
          },
        }}
      />

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        PaperProps={{
          sx: {
            position: "fixed",
            right: "10%",
            top: "32%",
            margin: 0,
            // height: "100vh",
            width: 400, // adjust width as needed
            maxWidth: "100%",
            borderRadius: "0",
          },
        }}
      >
        {/* <DialogTitle>Filters</DialogTitle> */}

        <DialogTitle
          sx={{
            borderBottom: "1px solid #E5E7EB",
            px: 3,
            py: 2,
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Stack direction="row" spacing={2} alignItems="center">
              <FilterListIcon
                sx={{
                  color: "#00527D",
                }}
              />

              <Typography variant="h6" fontWeight={600}>
                Filters
              </Typography>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center">
              <Button variant="outlined" size="small" onClick={handleClear}>
                Clear All
              </Button>

              <IconButton
                aria-label="cancel"
                size="small"
                onClick={() => setOpen(false)}
              >
                <CloseIcon />
              </IconButton>
            </Stack>
          </Stack>
        </DialogTitle>

        <DialogContent>
          <Box display="flex" flexDirection="column" gap={1} mt={1}>
            <MuiAutocomplete
              name="customer"
              options={customersData}
              setValue={(name, newValue) => {
                setCustomer(newValue);
                setAccount(null);
                setBatchAssessment(null);
                dispatch(
                  getAccountById({ assessmentCustomerId: newValue?.id }),
                );
                dispatch(
                  getBatchPublishAssessmentById({ customerId: newValue?.id }),
                );
              }}
              value={customer}
              size="small"
              height="100%"
              fullWidth={true}
              noMargin
              optionValue="customerName"
              // optionSecValue="code"
              label="Customer Name"
            />

            <MuiAutocomplete
              name="account"
              options={accountIdData}
              setValue={(name, newValue) => {
                setAccount(newValue);
                dispatch(
                  getBatchPublishAssessmentById({
                    customerId: customer?.id,
                    accountId: newValue?.id,
                  }),
                );
              }}
              value={account}
              size="small"
              height="100%"
              fullWidth={true}
              noMargin
              optionValue="accountName"
              // optionSecValue="code"
              label="Account Name"
            />

            {/* Customer */}

            {/* Account */}

            {/* Assessment Type */}
          </Box>
        </DialogContent>
      </Dialog>

      {showAdd && (
        <CommonCurdPopUp
          heading={`Add More Assessments`}
          mediumScreen={true}
          close={closeModel}
          handleSubmit={handleSubmit}
          loading={loading}
        >
          <Grid container>
            <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
            <Grid item xs={12} sm={12} md={11}>
              <MyTextInput
                disabled
                // InputLabelProps={{ shrink: true }}
                label="Batch Name"
                // required={true}
                type="text"
                name="batchName"
                fullWidth={true}
                margin="normal"
                id="batchName"
                value={formik.values.batchName}
                onChange={formik.handleChange}
                // error={
                //     formik.touched.batchName &&
                //     Boolean(formik.errors.batchName)
                // }
                // helperText={
                //     formik.touched.batchName &&
                //     formik.errors.batchName
                // }
              />
              <MuiAutocomplete
                multiple
                name="assessment"
                options={
                  nonPublishAssessmentData?.length > 0
                    ? nonPublishAssessmentData.filter((item) => {
                        const templateIds = new Set(
                          batchAssessmentData?.data?.assessments?.map(
                            (a) => `${a.assessmentTemplateId}-${a.clientEmail}`,
                          ) || [],
                        );

                        return !templateIds.has(
                          `${item?.assessmentTemplate?.id}-${item?.assessmentCustomerUser?.email}`,
                        );
                      })
                    : []
                }
                setValue={(name, newValue) => {
                  formik.setFieldValue(name, newValue);
                }}
                value={formik.values.assessment}
                optionValue="assessmentTemplate"
                optionSecValue="assessmentTemplateName"
                optionFourthValue={true}
                // innerValue={true}
                label="Assessment Name"
                // required={true}
                // error={
                //     formik.touched.assessment &&
                //     Boolean(formik.errors.assessment)
                // }
                // helperText={
                //     formik.touched.assessment && formik.errors.assessment
                // }
              />
            </Grid>
          </Grid>
        </CommonCurdPopUp>
      )}

      {showAssessor && (
        <CommonCurdPopUp
          // isDownload={true}
          // TARGET_URL={GET_ALL_STATUS_EXCEL_DOWNLOAD}
          // targetId={props?.statusTracking}
          // downloadFunc={downLoadFunc}
          heading={`Assessor Detail`}
          mediumScreen={true}
          close={() => setShowAssessor(false)}
        >
          <div
            // style={{ marginLeft: "20px", marginRight: "20px" }}
            className="res_tcTestData"
          >
            <MuiDataGrid
              data={data}
              // select={(item) => {
              //   if (item.length > 0) {
              //     setShowDetailData(item);
              //     // setShowDetail(true);
              //   }
              // }}
            />
          </div>
        </CommonCurdPopUp>
      )}

      {showAssessmentUsers && (
        <CommonCurdPopUp
          // isDownload={true}
          // TARGET_URL={GET_ALL_STATUS_EXCEL_DOWNLOAD}
          // targetId={props?.statusTracking}
          // downloadFunc={downLoadFunc}
          isViewClientAssessor={true}
          clientAssessorsData={clientAssessorsData}
          sendReminderEmailBySelection={showSendSelectedReminder}
          heading={`Client and Assessor Details`}
          mediumScreen={true}
          close={() => setShowAssessmentUsers(false)}
        >
          <Box
            sx={{
              width: "100%",
              overflowX: isNotLaptop ? "auto" : undefined,
            }}
          >
            <Box
              sx={{
                width: "100%",
                ...(isNotLaptop && {
                  minWidth: 1200,
                }),
              }}
            >
              <TableContainer
                component={Paper}
                sx={{
                  width: "100%",
                  overflowX: "auto",
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                  minHeight: 300, // minimum table area height
                }}
              >
                <Table
                  size="small"
                  size="small"
                  sx={{
                    width: "100%",
                    // minWidth: totalColumnWidth,
                  }}
                >
                  <TableHead>
                    <TableRow
                      sx={{
                        backgroundColor: "#E5E7EB",
                        "& th": {
                          fontWeight: 600,
                          color: "#374151",
                          borderBottom: "1px solid #D1D5DB",
                          whiteSpace: "nowrap",
                        },
                      }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={
                            clientAssessorsData?.length > 0 &&
                            totalSelected === clientAssessorsData.length
                          }
                          indeterminate={
                            totalSelected > 0 &&
                            totalSelected < clientAssessorsData?.length
                          }
                          onChange={handleSelectAll}
                        />
                      </TableCell>
                      {userscolumns.map((column) => (
                        <TableCell
                          key={column.field}
                          sx={{
                            width: `${100 / userscolumns.length}%`,
                            minWidth: column.width,
                          }}
                        >
                          {column.header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {clientAssessorsData?.map((item) => (
                      <TableRow
                        key={item.id}
                        hover
                        // selected={selectedRows.includes(item.assessmentTrackingId)}
                        sx={{
                          backgroundColor: "#F9FAFB",
                          "&:hover": {
                            backgroundColor: "#F3F4F6",
                          },
                          "& td": {
                            borderBottom: "1px solid #E5E7EB",
                          },
                        }}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={
                              selectedUsers.clients?.includes(item.id) ||
                              selectedUsers.assessors?.includes(item.id)
                            }
                            onChange={() => handleRowSelect(item)}
                          />
                        </TableCell>
                        <TableCell sx={{ width: columns[0].width }}>
                          {item.name}
                        </TableCell>

                        <TableCell sx={{ width: columns[1].width }}>
                          {item.email}
                        </TableCell>

                        <TableCell sx={{ width: columns[2].width }}>
                          {item.role === "client" ? "Client" : "Assessor"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
          <TablePagination
            component="div"
            count={clientAssessorsData.length}
            page={pageUsers}
            rowsPerPage={rowsPerPageUsers}
            onPageChange={(e, newPage) => setPageUsers(newPage)}
            onRowsPerPageChange={(e) => {
              setRowsPerPageUsers(parseInt(e.target.value, 10));
              setPageUsers(0);
            }}
            rowsPerPageOptions={[10, 25, 50]}
            sx={{
              border: "1px solid #D9E2EC",
              borderTop: "none",
              backgroundColor: "#fff",
              ".MuiTablePagination-toolbar": {
                minHeight: 52,
              },
            }}
          />
        </CommonCurdPopUp>
      )}

      <ConfirmDialog
        isViewClientAssessor={isViewClientAssessor}
        confirmDialog={confirmDialog}
        setConfirmDialog={(obj) => handleSetConfirmDialog(obj)}
      />
    </div>
  );
}
